import $ from "jquery";
import Screen from "./classes/screen";
import { lessons, lessonsTitle } from "./lessons";
import User from "./classes/user";
import "./styles/app.scss";

var allOptions, currentLesson;

let body = `
<div class='stretch flex-center flex-column chess-app'>
  <header class='page-header flex flex-space-between full-width'>
    <div class='header-section full-width flex-center'>
      <span class='title-bold'>FIRST MOVE FOR KIDS</span>
    </div>
    <div class='header-section full-width flex-vertical-center'>
      <ul class="select-box flex flex-column sub-title-bold padding-left">
        <li class="init lesson-list">Pre-Assessment</li>
        <ul class="scroll-dropdown">
        ${lessonsTitle.map((item, index) => {
    return `<li class="lesson-list" data-value=${index}>${item}</li>`
  }).join('')}
        </ul>
      </ul>
    </div>
    <div class='header-section full-width flex-vertical-center'>
      <span class='sub-title-bold padding-left'>VIEW ALL LESSONS</span>
    </div>
    <div class='header-section full-width flex-vertical-center'>
      <div class='user-profile  flex-vertical-center padding-left'>
        <img src='/img/user.png'><span class='user-name sub-title-bold padding-left'>Hi User</span>
      </div>
    </div>
  </header>
  <div class='page-body stretch flex'>
    <div class='overlay hide'></div>
    <div class='left-box flex flex-full flex-center full-height'>
      <div class='back-btn-container flex-center full-height'>
        <button id='previous' class='btn flex-center hide'><img src='/img/back.svg'></button>
      </div>
      <div class='left-box-content full-height full-width flex-center'></div>
    </div>
    <div class='center-box flex-center full-height'>
      <video controls controlsList="nofullscreen nodownload noremoteplayback" id='chessVideo' class="intro-video hide" autoplay>
        <source src="img/lesson_1.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
      <audio id="chessAudio" autoplay>
        <source src="" type="audio/mpeg" autoplay>
        Your browser does not support the audio element.
      </audio>
      <div class='chessboard-container flex-center flex-column'>
        <div id="chessBoard" class='chessboard'></div>
      </div>
      <div class='qa-section-container'>
        <div class='qa-section-content flex-center flex-full full-width full-height'></div>
      </div>
      <div class='activity-section-container'>
        <div class='activity-section-content flex-center flex-full full-width full-height'></div>
      </div>
    </div>
    <div class='right-box flex flex-full flex-center'>
      <div class='right-box-content flex-center full-height'></div>
      <div class='next-btn-container flex-center full-height'>
        <div class="volume-control flex-center"></div>
        <button id='next' class='btn flex-center hide'><img src='/img/next.svg'></button>
      </div>
    </div>
  </div>
<div>`;

// lesson dropdown
$(document).on("click", ".init", function(e) {
  e.preventDefault();
  e.stopPropagation();
  $('.scroll-dropdown').toggle();
  // $(".select-box li:nth-child(" + (currentLesson + 1) + ")").addClass(
  //   "selected"
  // );
});

$(document).on("click", ".lesson-list:not(.init)", function() {
$('.scroll-dropdown').toggle();
  $(document).trigger('next-config', [0, true]);
  let selectedValue = parseInt($(this).attr("data-value"), 10);

   $('.scroll-dropdown > li').removeClass('selected');
   $(this).addClass('selected');

  if (currentLesson !== selectedValue) {
    currentLesson = selectedValue;
    $(document).trigger("next-config", [0, true]);
  }

  $(".select-box")
    .children(".init")
    .html($(this).html());
  allOptions.toggle();
});

$(document).bind("click", function(e) {
  var $clicked = $(e.target);
  if (!$clicked.parents().hasClass("select-box")) allOptions.hide();
});

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

$(document).ready(function() {

  var username   = getParameterByName('username') || 'Anonymous';
  var student_id = getParameterByName('student_id') || 0;
  var playVideo  = getParameterByName('PlayVideo');

  if(playVideo){
    let lessonNum = playVideo.split("_").pop();
    currentLesson = isNaN(lessonNum)? 1 : Number(lessonNum);
    if(currentLesson >= 21 ){
      currentLesson = 20
    }
  }
  let user = { id: student_id, name: username, currentLesson: currentLesson };
  User.user = user;

  loadRoot(currentLesson);
});

$(document).on("click", "#next", function(e) {
  $(document).trigger("next-config");
});

$(document).on("click", "#previous", function(e) {
  $(document).trigger("previous-config");
});

window.addEventListener("resize", function(event) {
  $(".bubble").css("height", $(".bubble").width());
  updateScreen();
});

/**
 * @name removeComponents
 * @function
 * @param {}
 * @description: Remove components form the screen
 */
function removeComponents(currentChapter) {
  let removeBubble =
    currentChapter && currentChapter.text && currentChapter.text.continue
      ? false
      : true;

  if (removeBubble) {
    $(document).trigger("bubble-hide");
  }

  $(document).trigger("video-hide");
  $(document).trigger("chessBoard-hide");
  $(document).trigger("chessBoard-destroy");
  $(document).trigger("qa-bubble-hide");
  $(document).trigger("activity-hide");
  $(document).trigger("direction-box-hide");
  $(document).trigger("options-hide");
  $(document).trigger("canvas-hide");
  $(document).trigger("clear-timer");

  $("#chessBoard").attr("class", "chessboard");
  $(".castling-head").remove();
}

/**
 * @name updateScreen
 * @function
 * @param {}
 * @description: update the component size
 */
function updateScreen() {
  let windowWidht = $(".page-body").width(),
    windowHeight = $(".page-body").height(),
    contentHeight = windowHeight,
    contentWidth = (windowHeight * 1.78),
    placeholderWidth = (42 * windowWidht) / 100;

  if (contentWidth > windowWidht) {
    contentWidth = contentWidth > windowWidht ? windowWidht : contentWidth;
    contentHeight = contentWidth / 1.78;
  }

  $("#chessVideo").css("height", contentHeight);
  $("#chessVideo, #myCanvas").css("width", contentWidth);
  $(".qa-section-container").css("width", placeholderWidth);
  $(".qa-section-container").css("height", placeholderWidth);
  $(".chessboard-container, .activity-section-container").css(
    "width",
    placeholderWidth + 50
  );
  $(".chessboard-container, .activity-section-container").css(
    "height",
    placeholderWidth
  );
}

/**
 * @name updateNavigationButtons
 * @function
 * @param {previous, next} previous and next state
 * @description: Enable/Disable the navigation buttons
 */
function updateNavigationButtons(previous, next) {
  if (previous === null) {
    $("#previous")
      .removeClass("show")
      .addClass("hide");
  } else {
    $("#previous")
      .removeClass("hide")
      .addClass("show");
  }

  if (next === null) {
    $("#next")
      .removeClass("show")
      .addClass("hide");
  } else {
    $("#next")
      .removeClass("hide")
      .addClass("show");
  }
}

/**
 * @name loadRoot
 * @function
 * @param {Object} initialState : current lesson state
 * @description: Load screen with current lesson details
 */
function loadRoot(initialState = 0) {
  $("body")
    .html(body)
    .ready(function() {
      let screen = new Screen(),
        currentLessonId = initialState,
        currentChapterId = 0,
        currentChapter = lessons[currentLessonId].config[currentChapterId],
        previous = currentChapter ? currentChapter.previous : null,
        next = currentChapter ? currentChapter.next : null,
        nextConfig,
        previousConfig;

      Screen.loadPreloadedLessonsArray();
      Screen.updatePreloadedLessonsArray(
        currentLessonId,
        true,
        lessons[currentLessonId].assets
      );
      $(".chess-app").attr(
        "class",
        `stretch flex-center flex-column chess-app lesson-${currentLessonId}`
      );
      User.user.currentLesson = currentLessonId;
      updateNavigationButtons(previous, next);
      $(".header-section .user-name").html(`Hi ${User.user.name}`);
      screen.renderLesson(currentChapter);
      allOptions = $(".select-box").children("li:not(.init)");
      $(".lesson-list")[parseInt(initialState, 10) + 1].click();
      $(".init")[0].click();
      updateScreen();
      currentLesson = currentLessonId;

      $(document)
        .bind("next-config", function(e, configId, lessonChange = false) {
          nextConfig = configId === undefined ? currentChapter.next : configId;

          if (nextConfig === undefined || nextConfig === null) {
            removeComponents();
            return false;
          }

          if (lessonChange) {
            Screen.updatePreloadedLessonsArray(
              currentLesson,
              true,
              lessons[currentLesson].assets
            );
          }

          currentChapter = lessons[currentLesson].config[nextConfig];
          removeComponents(currentChapter);
          previous = currentChapter.previous;
          next = currentChapter.next;
          $(".chess-app").attr(
            "class",
            `stretch flex-center flex-column chess-app lesson-${currentLesson}`
          );
          updateNavigationButtons(previous, next);
          screen.renderLesson(currentChapter);
        })
        .bind(screen);

      $(document)
        .bind("previous-config", function(e, configId) {
          removeComponents();
          previousConfig =
            configId === undefined ? currentChapter.previous : configId;

          if (previousConfig === undefined || previousConfig === null) {
            return false;
          }

          currentChapter =
            lessons[currentLesson].config[currentChapter.previous];
          previous = currentChapter.previous;
          next = currentChapter.next;
          $(".chess-app").attr(
            "class",
            `stretch flex-center flex-column chess-app lesson-${currentLesson}`
          );
          updateNavigationButtons(previous, next);
          screen.renderLesson(currentChapter);
        })
        .bind(screen);
    });
}



// WEBPACK FOOTER //
// ./src/index.js